import React, { useRef, useState, useMemo, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Button, Grid } from '@mui/material';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import Spinner2 from '../../common/Spinner/Spinner2';
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import { getVehicles, fetchSavedView, baseUrl } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import ModalComponent from '../../common/Modal/ModalComponent';
import ResourceDetails from '../../../../shared/common-utilities/common/ResourceDetails/ResourceDetails';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent';
import ActionButton from '../../../../shared/common-utilities/common/ActionButton';
import WindowComponent from '../../common/Window/WindowComponent';
import i18_en from '../../../../jsonStore/i18_en.json';
import { MessageComponent, RenderActionButtons } from '../../../../shared/common-utilities/common/DeleteConfirmationComponent';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService';

const entity = "vehicle";
let entityNameFor = "vehicle";
const odataApiName = "vehicles";
let odataApiNameFor = "vehicles";
let service = getSetDataService();
let dataService = dataStorageService();
let apiService = commonApiService();
const dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'Refresh', 'New Window'];
let gridSelectedValues = {};
//#region SortData start


const VehicleResource = (props) => {
    //#region Reference
    const vehicleResGrid = useRef(null);
    //#endregion Reference

    //#region Hook Selctor
    //#endregion Hook Selctor

    const vehicleResGriddDtaItemKey = "id";
    const initialSort = service.initialSort[entity];

    //#region States - Get set variables  
    const [tempVehicleResData, setTempVehicleResData] = useState([]);
    const [vehicleResGridColumnList, setVehicleResGridColumnList] = useState(null);
    const [tempVehicleResGridColumnList, setTempVehicleResGridColumnList] = useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isVehicleResource, setIsVehicleResource] = useState(true);
    const [loadedGridData, setLoadedGridData] = useState(tempVehicleResData);
    const [myGridData, setmyGridData] = React.useState([]);
    const [loadSelectionValue, setloadSelectionValue] = useState(100);
    const [totalData, setTotalData] = useState();
    const userID = localStorage.getItem('userID');
    const vehicleType = "TRUCK";

    const [isApiLoaded, setIsApiLoaded] = useState(false);
    const [paramsData, setParamsData] = useState(null);
    let [initialFilter, setInitialFilter] = useState([]);
    const [nextDataUrl, setNextDataUrl] = useState(null);
    const [vehicleData, setVehicleData] = useState({});
    const [initialSaveViewData, setInitialSaveViewData] = useState([]);
    const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
    const [vehicleResource, setVehicleResource] = useState({});
    const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
    const [errorSnackbarMessageVHR, setErrorSnackbarMessageVHR] = useState('');
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [isResourceLoad, setIsResourceLoad] = useState(false);
    const [changeToChildVHR, setChangeToChildVHR] = useState(null);
    const [isApiCallRequired, setIsApiCallRequired] = useState(true);
    const [openConfirmationModal, setopenConfirmationModal] = useState(false);
    const [commonPopupParameters, setCommonPopupParameters] = React.useState({});
    const [errorMessage, setErrorMessage] = useState(null);
    const [canExecute, setCanExecute] = useState([]);

    const vehicleResFilterComponents = [
        // { type: 'DropDownList', key: 'vehicleType', value: "TRUCK", label: 'Vehicle Type', data: ["All", "TRUCK", "VAN", "2-ton forklift truck"] },
    ];
    const vehicleResDetails = [
        { label: 'Vehicle Code', value: vehicleResource[0]?.codeVehicle },
        { label: 'Vehicle Type ', value: vehicleResource[0]?.vehicleType },
        { label: 'Brand ', value: vehicleResource[0]?.brand },
        { label: 'Number Plate', value: vehicleResource[0]?.numberplate },
    ];
    const metaData = JSON.parse(dataService.getLocalStorageData("metaData"))

    //#endregion States

    //#region Hooks  

    useEffect(() => {
        // setIsLoading(true);
        setIsApiLoaded(true);
        odataApiNameFor = odataApiName;
        entityNameFor = entity;
        if (props?.gridFlagVal) {
            odataApiNameFor += props?.gridFlagVal;
            entityNameFor += props?.gridFlagVal;
        }
        setTimeout(()=>{
            setGridColumns(entity);
        },100)
        let tempFilterData = [];

        // tempFilterData.push({ field: 'vehicleType', value: '=' + vehicleType, isLast: false, type: 'Edm.String' });
        let userData = service.getUserFilterData(entity);
        const mergedArray = tempFilterData.concat(userData);
        setInitialFilter(mergedArray);
    }, []);

    const setGridColumns = (entityName) => {
        const columnList = localStorage.getItem(entityNameFor + 'ColumnList');
        if (!_.isNil(columnList)) {
            setVehicleResGridColumnList(JSON.parse(columnList));
            getColList(JSON.parse(columnList));
            return true;
        }

        if(!_.isNil(metaData) || metaData !== "undefined") {
            service.entityDefinitions(metaData, entityName).then((tempFieldList) => {
                localStorage.setItem(entityNameFor + 'ColumnList', JSON.stringify(tempFieldList));
                setVehicleResGridColumnList(tempFieldList);
                getColList(tempFieldList);
            })
        }
    }

    const getDefaultColList = (dcolsStringVHR, gridcolumns) => {
        const dColsVHR = JSON.parse(localStorage.getItem("defaultColumnSetting"));
        if (!_.isNil(dcolsStringVHR) && dcolsStringVHR != "undefined") {
            const defaultColumnListVHR = gridcolumns?.filter(item => {
                return dColsVHR[entity]?.split("~").includes(item.field);
            });
            if (defaultColumnListVHR.length == 0) {
                localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
                setTempVehicleResGridColumnList(gridcolumns);
            } else {
                const sortedArr = _.sortBy(defaultColumnListVHR, function (item) { return dColsVHR[entity]?.split("~").indexOf(item.field) });
                localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(sortedArr));
                setTempVehicleResGridColumnList(sortedArr);

                const arr1 = sortedArr;
                const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
                const newsortedArr = _.concat(arr1, arr2);
                setVehicleResGridColumnList(newsortedArr);
            }
        } else {
            localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
            setTempVehicleResGridColumnList(gridcolumns);
        }
    }

    const getColList = (gridcolumns) => {
        const vhrUrl = `${fetchSavedView}?$filter=(title eq '${odataApiNameFor}' and userID eq '${userID}')`;
        const dcolsStringVHR = localStorage.getItem("defaultColumnSetting");
        apiService.get(vhrUrl).then(savedViewRes => {
            if (savedViewRes?.value?.length > 0) {
                apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], null, null, null, null, savedViewRes.value[0]["@odata.etag"]).then(readResVHR => {
                    if (readResVHR !== undefined && readResVHR !== null) {
                        setInitialSaveViewData(savedViewRes.value);
                        setInitialFetchReadLinkData(readResVHR);
                        const defaultViewExist = readResVHR[odataApiNameFor]?.savedViews?.filter(item => item.defaultView);
                        if (defaultViewExist?.length > 0 && defaultViewExist?.[0]?.subviews?.length > 0) {
                            setCanExecute(defaultViewExist);
                            const favFilterExist = defaultViewExist[0]?.subviews?.filter(subView => subView.isDefaultFilter);
                            if (favFilterExist?.length > 0) {
                                setTempVehicleResGridColumnList(defaultViewExist[0].columns);
                            }
                        } else if (readResVHR[odataApiNameFor]?.columns?.length !== 0) {
                            localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(readResVHR[odataApiNameFor]?.columns));
                            setTempVehicleResGridColumnList(readResVHR[odataApiNameFor]?.columns);
                        } else {
                            getDefaultColList(dcolsStringVHR, gridcolumns);
                        }
                    }
                })
            } else {
                getDefaultColList(dcolsStringVHR, gridcolumns);
            }

            setIsLoading(false);
        });
    }

    useEffect((e) => {
        if (!_.isNil(paramsData) && isApiCallRequired) {
            updateSendApi(loadSelectionValue);
            // sendApi(null, loadSelectionValue);
        } else {
            setIsApiCallRequired(true);
        }
    }, [paramsData]);

    useEffect((e) => {
        if (!_.isNil(tempVehicleResGridColumnList)) {
            setNextDataUrl(null);
            updateSendApi(loadSelectionValue);
        }
    }, [tempVehicleResGridColumnList]);

    useEffect(() => {
        if (!_.isNil(props.resourceData)) {
            const url = `${baseUrl}/vehicles?&$filter=(codeVehicle eq '${props?.resourceData}')`;
            apiService.get(url).then(res => {
                if (res !== null && res !== undefined) {
                    setVehicleResource(res.value);
                    setIsResourceLoad(true);
                }
            })
        }
    }, [])

    //#endregion Hooks

    //#region Methods

    // --- API's Call START ---

    const sendApi = (val, size) => {
        let filter = paramsData?.filter ? '$filter=(' + paramsData?.filter + ')' : null;
        let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
        if (canExecute?.length > 0) {
            return;
        }
        if (tempVehicleResGridColumnList !== null && tempVehicleResGridColumnList !== undefined && tempVehicleResGridColumnList?.length > 0) {
            setIsLoading(true);
            const params = '&' + filter + '&' + orderby + '&$count=true';
            const columns = tempVehicleResGridColumnList?.map(item => item.field);
            const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
            if (!_.isNull(mandatroyEntity)) {
                let splitedColums = mandatroyEntity.mandatoryColumns.split("~");
                splitedColums.forEach(element => {
                    if (!columns.includes(element)) {
                        columns.push(element)
                    }
                });
            }
            const selectFields = `&$select=${columns}`;
            const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
            apiService.get(getVehicles, params, `${selectFields}`, oDataNextLink, size, null).then(response => {
                if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
                    setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
                    if (response?.error?.message?.includes('$orderby')) {
                      const sortToRemoveVHR = response.error.message.split("'")[1];
                      setChangeToChildVHR({ type: "sort", value: sortToRemoveVHR });
                    } else if (response?.error?.code == "Application_FilterErrorException") {
                      const filterToRemoveVHR = response.error.message.split("'")[1];
                      setChangeToChildVHR({ type: "filter", value: filterToRemoveVHR });
                    }
                } else {
                    if (response.value) {
                        setTotalData(response["@odata.count"]);
                        let tempData = [];
                        if (val == 'Scroll' && tempVehicleResData !== null && tempVehicleResData !== undefined && tempVehicleResData.length > 0) {
                            tempVehicleResData.forEach(tempVehicleRes => {
                                tempData.push(tempVehicleRes);
                            });
                            response.value.map(temp => {
                                tempData.push(temp)
                            })
                        }
                        // Update the data based on the response
                        else {
                            tempData = response.value;
                        }
                        tempData = service.setColorCodeAndDate(tempData, vehicleResGridColumnList);
                        setIsApiLoaded(true);
                        if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
                            setNextDataUrl(response['@odata.nextLink']);
                        }
                        
                        setmyGridData(tempData);
                        setLoadedGridData(tempData);
                        setTempVehicleResData(tempData);
                    }
                }
            })
            .catch(error => {
                console.error('API error:', error);
            })
            .finally(() => {
                setIsLoading(false);
                if (props?.sendDataToParent) {
                    props.sendDataToParent(odataApiName);
                }
            });
        } else {
            setIsLoading(false);
        }
    }

    const updateSendApi = useMemo(() => {
        return _.debounce((size) => {
          sendApi(null, size);
        }, 250);
    }, [sendApi]);

    // --- API's Call END ---

    const childStateHandler = (value, flag) => {
        if (flag === 'showGridHeader') {
            setIsVehicleResource(value);
        } else if (flag === 'getData') {
            setNextDataUrl(null);
            setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
            setIsApiCallRequired(value.isApiCall);
            setTempVehicleResGridColumnList(value.columns);
            setCanExecute([]);
        } else if (flag === 'refresh') {
            sendApi(null, loadSelectionValue);
        } else if (flag === 'selectedValues') {
            gridSelectedValues = value;
        } else if (flag === 'dataItem') {
            setVehicleData(value);
        } else if (flag === 'columnsVisible') {
            setTempVehicleResGridColumnList(value);
        }
    }

    // --- Common methods END ---

    //#endregion Methods

    //#region Not in use

    //#endregion

    const closePopup = () => {
        props.onClose();
    }

    const onOkClick = () => {
        let transferdataId = Object.entries(gridSelectedValues).filter(([key, value]) => value === true).map(([key]) => key);
        if (transferdataId.length === 0) {
            setErrorSnackbarMessageVHR('Please select vehicle resource');
            setErrorSnackbarOpen(true);
            return;
        }
        props?.addResourceApi(vehicleData);
        // props.onClose();
    }
    const handleErrorSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorSnackbarOpen(false);
    };

    const deAllocateResource = () => {
        props?.addResourceApi({ codeVehicle: "" });
    }

    const onLoadSelectionChangeVHR = (e) => {
        let value = e.value;
        setloadSelectionValue(value);
        sendApi(null, value);
    }

    const setErrorParameterAndMessage = (errMsg) => {
        setCommonPopupParameters({
          title: 'Error'
        });
        setErrorMessage(errMsg);
        setopenConfirmationModal(true);
    }

    const closeConfirmationModalVHR = () => {
        setopenConfirmationModal(false);
    }

    return (
        <>
            {isLoading ? (<Spinner2 isAll={loadSelectionValue} />) : (<></>)}
            <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }} id={odataApiName}>

                <AlertComponent isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessageVHR} handleErrorSnackbarClose={handleErrorSnackbarClose} />

                {
                    props.resourceData != null && isResourceLoad && (
                        <>
                            {vehicleResource.length > 0 ? (
                                <>
                                    <ResourceDetails details={vehicleResDetails} onDeallocate={() => setIsDeleteDialogOpen(true)} />
                                </>
                            ) : (
                                <Typography color="#ce0000" variant="body2" sx={{ fontWeight: 'bold', paddingBottom: '7px', textAlign: 'center' }}> Allocated Vehicle ({props?.resourceData}) doesn't exists!</Typography>
                            )}


                        </>
                    )
                }
                {isVehicleResource &&
                    <Box className="headBG" sx={{ px: 1, width: '100%', display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Vehicle Resource</Typography>
                    </Box>
                }

                <Grid container sx={{ marginTop: 0 }} className='filterbar-bg'>
                    <Grid item={true} xs component={Card} elevation={0} pl={0} sx={{ flexGrow: 1 }} className='grid-movement'>
                        {isApiLoaded && <DataGridComponent
                            {...props}
                            gridRef={vehicleResGrid}
                            gridFlagVal={odataApiName}
                            gridFlagValFor={odataApiNameFor}
                            gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px', maxWidth: 'calc(100%)', width: '100%' }}
                            entity={entity}
                            gridNewData={myGridData}
                            loadedGridData={loadedGridData}
                            tempGridData={tempVehicleResData}
                            gridColumnList={vehicleResGridColumnList ? vehicleResGridColumnList : []}
                            gridTempColumnList={tempVehicleResGridColumnList ? tempVehicleResGridColumnList : []}
                            gridSort={initialSort}
                            isItemVisible={false}
                            gridInitialFilter={initialFilter}
                            isShowGridHeader={isVehicleResource}
                            griddDtaItemKey={vehicleResGriddDtaItemKey}
                            gridDraggable={false}
                            sendDataToParent={childStateHandler}
                            gridDataAction={dataRelatedAction}
                            gridFilterComponents={vehicleResFilterComponents}
                            onLoadSelectionChange={onLoadSelectionChangeVHR}
                            loadSelectionValue={loadSelectionValue}
                            gridtotalData={totalData}
                            initialSaveViewData={initialSaveViewData}
                            initialFetchReadLinkData={initialFetchReadLinkData}
                            selectableMode={"single"}
                            changeToChild={changeToChildVHR}
                        />}
                    </Grid>
                </Grid>
            </Grid>
            {isDeleteDialogOpen && <WindowComponent title={i18_en.confirmDeallocateRes} visible={isDeleteDialogOpen} initialWidth={400} initialHeight={200} minWidth={400} minHeight={200} onClose={() => setIsDeleteDialogOpen(false)} dataComponent={MessageComponent} actionButtons={<RenderActionButtons onClose={() => setIsDeleteDialogOpen(false)} onConfirm={deAllocateResource}/>} resizable={false} minimizeButton={() => { return null }} maximizeButton={() => { return null }} doubleClickStageChange={false}/>}
            {
                props?.openAddColumnModal && (
                    <ActionButton onOkClick={onOkClick} closePopup={closePopup}/>
                )
            }
            <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModalVHR} />
        </>
    )
};

export default VehicleResource;
